export default __webpack_public_path__ + "static/media/scdream6.365576a4.woff";